import type { CoreStatus, KpiStatus } from '../types/bsc';

export const PERSPECTIVE_ORDER = [
  'Finanziaria',
  'Commerciale',
  'Personale',
  'Ricerca&Sviluppo',
] as const;

export const MULTILINE_KPIS = new Set([
  'COM-01',
  'COM-02',
  'PER-02',
  'PER-03',
  'PER-05',
  'RND-01',
  'RND-02',
]);

export const SERIES_SHEETS: Record<
  string,
  { valueColumns: string[]; defaultNote: string }
> = {
  'COM-01': {
    valueColumns: ['offerte_acquisite'],
    defaultNote: 'Percentuale offerte acquisite per Business Unit',
  },
  'COM-02': {
    valueColumns: ['media_margine'],
    defaultNote: 'Media margini commesse C per cliente',
  },
  'PER-02': {
    valueColumns: ['ferie_residue'],
    defaultNote: 'Ferie residue per reparto',
  },
  'PER-03': {
    valueColumns: ['efficienza_operativa'],
    defaultNote: 'Efficienza operativa',
  },
  'PER-05': {
    valueColumns: ['ore_var'],
    defaultNote: 'Ore su commesse VAR',
  },
  'RND-01': {
    valueColumns: ['conversazioni'],
    defaultNote: 'Conversazioni ChatGPT',
  },
  'RND-02': {
    valueColumns: ['efficienza', 'ore_risparmiate'],
    defaultNote: 'Efficienza AI',
  },
};

export const MULTILINE_PALETTE = [
  '#0072B2',
  '#E69F00',
  '#009E73',
  '#CC79A7',
  '#D55E00',
  '#56B4E9',
  '#7C3AED',
  '#0891B2',
  '#A16207',
];

export const STATUS_COLORS: Record<KpiStatus, string> = {
  Eccellente: '#17922A',
  'In target': '#1D76C0',
  'Sotto target': '#BD9400',
  'Fuori target': '#BD9400',
  Critico: '#AD1818',
  'Manca dato': '#6B7280',
  'Da definire': '#6B7280',
  'No target': '#6B7280',
};

export const CORE_STATUS_COLORS: Record<CoreStatus, string> = {
  Eccellente: STATUS_COLORS.Eccellente,
  'In target': STATUS_COLORS['In target'],
  'Fuori target': STATUS_COLORS['Fuori target'],
  Critico: STATUS_COLORS.Critico,
};

export const STATUS_PRIORITY: Record<KpiStatus, number> = {
  Critico: 4,
  'Sotto target': 3,
  'Fuori target': 3,
  'In target': 2,
  Eccellente: 1,
  'Manca dato': 0,
  'Da definire': 0,
  'No target': 0,
};

export const SOURCE_PRIORITY: Record<string, number> = {
  'manuale (Excel)': 20,
  imported: 15,
  calculated: 10,
};
